import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { POPULAR_SPORTS } from "./data";

export default function PopularSports() {
  return (
    <section className="border-y border-border bg-secondary/40">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Explore popular sports</h2>
            <p className="mt-2 text-sm text-muted-foreground">Tap a sport to find grounds and teams near you.</p>
          </div>
        </div>
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {POPULAR_SPORTS.map((s, i) => (
            <motion.div key={s.name} initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }} transition={{ duration: 0.3, delay: i * 0.04 }}>
              <Link to={`/browse?cat=facilities&sport=${encodeURIComponent(s.name)}`} data-testid={`sport-${s.name.toLowerCase()}`}
                className="group relative block aspect-[3/4] overflow-hidden rounded-2xl border border-border shadow-sm">
                <img src={s.img} alt={s.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
                <span className="absolute bottom-3 left-3 font-display text-lg font-bold text-white">{s.name}</span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
